module.exports = __webpack_public_path__ + "img/5-1.e8035734.png";